/* eslint-disable react/prop-types */
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { firebase } from "store/slices/firebaseSlice";

const PrivateRoute = ({ Component }) => {
  const { isAuth } = useSelector(firebase);
  return isAuth ? <Component /> : <Navigate to="/authentication/sign-in" />;
};
export default PrivateRoute;
